export default __webpack_public_path__ + "static/media/uniwave_color.129a936f.glb";